var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgDangerWarningYellow = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 12,
    viewBox: "0 0 15 12",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Danger"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Danger_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.15166 0.961394L13.9975 9.37148C14.1042 9.62251 14.1508 9.82663 14.1642 10.0387C14.1908 10.5341 14.0175 11.0157 13.6776 11.3863C13.3376 11.7556 12.8777 11.9736 12.3778 12H2.61943C2.4128 11.9874 2.20617 11.9405 2.01287 11.8679C1.04636 11.4781 0.579776 10.3815 0.973043 9.43093L5.85222 0.955449C6.01886 0.657519 6.27215 0.400546 6.58543 0.235396C7.49194 -0.26732 8.64508 0.0629796 9.15166 0.961394ZM8.07851 6.50382C8.07851 6.82091 7.81856 7.08581 7.49861 7.08581C7.17866 7.08581 6.91204 6.82091 6.91204 6.50382V4.63498C6.91204 4.31724 7.17866 4.06026 7.49861 4.06026C7.81856 4.06026 8.07851 4.31724 8.07851 4.63498V6.50382ZM7.49861 9.34505C7.17866 9.34505 6.91204 9.08015 6.91204 8.76373C6.91204 8.44598 7.17866 8.18174 7.49861 8.18174C7.81856 8.18174 8.07851 8.44003 8.07851 8.75646C8.07851 9.08015 7.81856 9.34505 7.49861 9.34505Z",
    fill: "#A17217"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDangerWarningYellow, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/DangerWarningYellow.4cb0be69.svg";
export { ForwardRef as ReactComponent };